function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#C4C4C4"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -5,
  width: 34,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: -5,
  y: 0,
  width: 34,
  height: 24
}, /*#__PURE__*/React.createElement("rect", {
  x: -5,
  width: 34,
  height: 24,
  rx: 2,
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -5,
  width: 34,
  height: 24,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.10391 16L-8.36792 23.6468L-6.5572 26.2997L7.95242 16.628V25.6H16.0477V16.6279L30.5574 26.2997L32.3681 23.6468L20.8963 16H29V8H20.8963L32.3681 0.353176L30.5574 -2.29974L16.0477 7.37204V-1.6H7.95242V7.37197L-6.55719 -2.29974L-8.36791 0.353177L3.10392 8H-4.99996V16H3.10391Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6682 7.59864L33.0476 -2.39999",
  stroke: "#DB1F35",
  strokeWidth: 0.666667,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.3013 16.437L33.0881 25.6204",
  stroke: "#DB1F35",
  strokeWidth: 0.666667,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.7209 7.57258L-9.65991 -2.00516",
  stroke: "#DB1F35",
  strokeWidth: 0.666667,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.28065 16.3259L-9.65991 26.7726",
  stroke: "#DB1F35",
  strokeWidth: 0.666667,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-5 14.4H9.57143V24H14.4286V14.4H29V9.6H14.4286V0H9.57143V9.6H-5V14.4Z",
  fill: "#E6273E"
})));

function SvgEngFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngFlag);
export default __webpack_public_path__ + "static/media/eng-flag.dafb2e2a.svg";
export { ForwardRef as ReactComponent };